import templatelist from '../../../playturbo/src/lang/en/templateList'
import versionlist from '../../../playturbo/src/lang/en/versionList'
import login from '../../../playturbo/src/lang/en/login'
import forget from '../../../playturbo/src/lang/en/forget'
import profile from '../../../playturbo/src/lang/en/profile'
import navbar from '../../../playturbo/src/lang/en/navbar'
import ptCommon from '../../../playturbo/src/lang/en/common'
import custom from '../../../playturbo/src/lang/en/custom'
import creative from '../../../playturbo/src/lang/en/creative'
import websocket from '../../../playturbo/src/lang/en/websocket'
import uploader from './en/uploader'
import cropperDialog from './en/cropperDialog'
import frameSelectDialog from './en/frameSelectDialog'
import gamePlay from '../../../playturbo/src/lang/en/gamePlay'
import report from '../../../playturbo/src/lang/en/report'
import common from './en/common.js'
import commonTemplate from '../../../playturbo/src/lang/en/commonTemplate.js'
import deliveryList from '../../../playturbo/src/lang/en/deliveryList'
import dispatcher from '../../../playturbo/src/lang/en/dispatcher'
import privacy from '../../../playturbo/src/lang/en/privacy'
import commonNavbar from './en/downloadBasic'
import basic from '@com/lang/en/basic'
import workbench from '@com/lang/en/workbench'
import userJourney from '@com/lang/en/userJourney'
import resourceManager from '@com/lang/en/resourceManager'
import record from '@pt/lang/en/record'
import account from '@pt/lang/en/account'
import guideTour from '@pt/lang/en/guideTour'
import home from '@pt/lang/en/home'
import leftMenu from '@pt/lang/en/leftMenu'
import navbarTool from '@pt/lang/en/navbarTool'
import whole from '@pt/lang/en/whole'
import assetLibrary from '@pt/lang/en/assetLibrary'
import exportHistory from '@pt/lang/en/exportHistory'
import picturesVideos from '@pt/lang/en/picturesVideos'
import playableAds from '@pt/lang/en/playableAds'
import playableProject from '@pt/lang/en/playableProject'
import promoteManagement from '@pt/lang/en/promoteManagement'
import recordManagement from '@pt/lang/en/recordManagement'
import recordProject from '@pt/lang/en/recordProject'
import templateLibrary from '@pt/lang/en/templateLibrary'
import videoProject from '@pt/lang/en/videoProject'
import dashboard from '@pt/lang/en/dashboard'
import ce from '@pt/lang/en/ce'
import locale from '@ve-pro/ve/lang/locales/en.json'
import taskCenter from '@pt/lang/en/taskCenter'
import pushDialog from '@pt/lang/en/pushDialog'
import authAccount from '@pt/lang/en/authAccount'
import billing from '@pt/lang/en/billing'
import activities from '@pt/lang/en/activities'
import rev from '@pt/lang/en/rev'
import preView from '@ps/lang/en/preview'
import trial from '@pt/lang/en/trial'
import register from '@pt/lang/en/register'
import order from '@pt/lang/en/order'
import permission from '@pt/lang/en/permission'
import payment from '@pt/lang/en/payment'
import voiceLab from '@pt/lang/en/voiceLab'
import aiBanner from '@pt/lang/en/aiBanner'
import aiLocale from '@ai/lang/locales/en.json'

// 引入视频编辑器国家化内容，由于视频编辑器key体系之后一级，配置在playTurbo字段会导致无法生成国际化配置，手动拼接playTurbo key名称引入到i18n根目录
const vePro = {}
Object.keys(locale).forEach((key) => {
  vePro['playTurbo.' + key] = locale[key]
})

export default {
  basic,
  workbench,
  userJourney,
  resourceManager,

  commonNavbar,
  form: {
    platform: 'Platform',
    type: 'Type',
    starttime: 'Starttime',
    timeseparator: 'to',
    endtime: 'Endtime',
    keyword: 'Keyword',
    search: 'Search',
    pastWeek: 'Past week',
    pastMonth: 'Past month',
    past3Month: 'Past 3 months',
    pastHalfYear: 'Past half year',
    pastYear: 'Past year',
  },
  common,
  uploader,
  cropperDialog,
  frameSelectDialog,
  playTurbo: {
    navbar,
    login,
    forget,
    profile,
    trial,
    register,
    templatelist,
    versionlist,
    common: ptCommon,
    commonTemplate,
    pushDialog,
    authAccount,
    custom,
    creative,
    gamePlay,
    report,
    deliveryList,
    websocket,
    dispatcher,
    privacy,
    record,
    account,
    guideTour,
    home,
    leftMenu,
    navbarTool,
    whole,
    ce,
    assetLibrary,
    exportHistory,
    picturesVideos,
    playableAds,
    playableProject,
    promoteManagement,
    recordManagement,
    recordProject,
    templateLibrary,
    videoProject,
    dashboard,
    taskCenter,
    billing,
    activities,
    rev,
    order,
    permission,
    payment,
    voiceLab,
    aiBanner,
  },
  preview: {
    preView,
  },
  ...vePro,
  ai: aiLocale,
}
